<template>
    <div class="videoResume">
        <div class="card p-4 pl-lg-5" v-if="pdfURL === null || pdfURL === undefined">
            <div class="card-body col-12 text-center pt-5 pb-5">
                <div class="p-2 d-flex flex-column text-center">
                    <img src="../../../assets/no_video.svg" width="noresume" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                    <span class="oopsnext proximanova">Text Resume not available</span>
                </div>
            </div>
        </div>
        <div class="col-12 pl-0 pr-0 mb-4 card introvideocard"  v-else>
            <iframe :src="pdfURL" class="textResumeIframe" title="Iframe Example"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    props : [
        'jobApplicantDetails'
    ],
    data() {
        return{
            pdfURL : null
        }
    },
    mounted(){
        this.pdfURL = this.jobApplicantDetails.pdfURL
    },
    methods : {
        
    }
}
</script>
<style scoped>
.textResumeIframe{
    width: 100%;
    height: 570px;
    overflow: auto;
}

@media screen and (min-width: 600px) {
  
}
</style>